import { lazy } from 'react';

import { retry } from 'app/utils/lib/file';

// Lazy-loaded route component
const LazyServerSettingsRoute = lazy(() => retry(() => import('app/pages/admin/ServerSettings')));

// Component wrapper type
type ComponentProps = Record<string, unknown>;

// Export component wrapper
export const ServerSettings = (props: ComponentProps) => <LazyServerSettingsRoute {...props} />;
